import {
  FormValidation,
  emailValidate,
  nameValidate,
} from '@data/other/validation';

export default class Guest {
  /* minimun fields to complete reservation */
  firstName!: string;
  lastName!: string;
  email!: string;

  gender?: 'M' | 'F' | 'N/A';
  phone?: string;

  country?: string;
  state?: string;
  zipCode?: string;
  city?: string;
  address1?: string;
  address2?: string;

  estimatedArrivalTime?: number;
  taxIdNumber?: string;
  companyName?: string;
  companyTaxIdNumber?: string;

  constructor(data: Dict[] | Dict = []) {
    if (!data) return;
    let guestFormData = data;
    if (Array.isArray(guestFormData)) {
      guestFormData = {};
      data.forEach((item) => {
        guestFormData[item.name] = item.value;
      });
    }

    this.firstName = guestFormData.first_name || '';
    this.lastName = guestFormData.last_name || '';
    this.email = guestFormData.email || '';
    this.phone = guestFormData.phone || '';
  }

  public static validationModel: FormValidation<Guest> = {
    firstName: { required: true, maxLength: 45, validate: nameValidate },
    lastName: { required: true, maxLength: 45, validate: nameValidate },
    email: { required: true, maxLength: 60, validate: emailValidate },
    phone: { required: true, maxLength: 40 },
    country: { required: true },
    taxIdNumber: { maxLength: 45 },
    address1: { maxLength: 95 },
    address2: { maxLength: 95 },
    city: { maxLength: 35 },
    zipCode: { maxLength: 12 },
    companyName: { maxLength: 45 },
    companyTaxIdNumber: { maxLength: 45 },
  };
}
